import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en';
import ar from './locales/ar';
import type { Locale } from '@/lib/api/types';

void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ar: { translation: ar },
  },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
  returnNull: false,
});

/** Apply chrome locale: set i18next language + <html lang/dir> (spec §5.3 / §6). */
export function applyChromeLocale(locale: Locale): void {
  void i18n.changeLanguage(locale);
  const html = document.documentElement;
  html.setAttribute('lang', locale);
  html.setAttribute('dir', locale === 'ar' ? 'rtl' : 'ltr');
}

export default i18n;
